import { useEffect, useState } from "react";

export default function Toast({ message, type = "success", onClose }) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
      onClose();
    }, 3000); // auto close in 3 sec
    return () => clearTimeout(timer);
  }, [onClose]);

  if (!show) return null;

  return (
    <div
      className={`toast align-items-center text-bg-${type} border-0 position-fixed bottom-0 end-0 m-3 show`}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      style={{ zIndex: 9999 }}
    >
      <div className="d-flex">
        <div className="toast-body">{message}</div>
        <button
          type="button"
          className="btn-close btn-close-white me-2 m-auto"
          onClick={() => {
            setShow(false);
            onClose();
          }}
        ></button>
      </div>
    </div>
  );
}
